// Configs
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

const root = {
  key: 'ICSRoot',
  storage: storage,
  blacklist: ['common',"modalReducer"],
};

const common = {
  key: 'ICSsCommon',
  storage: storage,
  whitelist: [],
  blacklist: ['common',"modalReducer"],
};

export { root, common};
